import React from "react";
import { Grid } from "@mui/material";
import FieldItem from "../../Widgets/FieldItem";
import { DiagnosticFormValues, Diagnosis } from "./interface";
import { AUTISM_DIAGNOSES_CODE, ASD_SEVERITY } from "./utils";
import { ADDITIONAL_DIAGNOSES } from "components/ClientDetails/Sections/Profile/DiagnosticProfile/selectValues";
interface ViewFieldsProps {
  diagnosticValues: DiagnosticFormValues;
  listOfDiagnosis: Diagnosis[];
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ diagnosticValues, listOfDiagnosis }) => {
  const {
    diagnosisId,
    diagnosisDate,
    medicalDiagnoses,
    asdSeveritySocial,
    asdSeverityRestricted,
    iqTest,
    iqScore,
    cars2Type,
    cars2TScore,
    treatmentModality,
    additionalDiagnoses,
    evaluationForComorbidDiagnoses,
    otherSymptomsObserved,
    persistentDeficitsSocialCommunication,
    restrictiveRepetitivePatterns,
  } = diagnosticValues;

  const findDiagnosisById = (diagnosisId: number | string) => {
    return listOfDiagnosis.find((diagnosis) => diagnosis.id === diagnosisId);
  };

  const diagnosis = findDiagnosisById(diagnosisId);

  const asdSeverityLabel = (asdSeverity: string) =>
    ASD_SEVERITY.find((severity) => severity.value === asdSeverity)?.label;

  const asdSeveritySocialLabel = asdSeverityLabel(asdSeveritySocial);
  const asdSeverityRestrictedLabel = asdSeverityLabel(asdSeverityRestricted);

  const formattedDate = diagnosisDate ? diagnosisDate.toLocaleDateString() : "-";

  const additionalDiagnosesLabel =
    additionalDiagnoses
      ?.map((diagnosis) => ADDITIONAL_DIAGNOSES.find((d) => d.code === diagnosis)?.label)
      ?.join(", ") || "-";

  const medicalDiagnosesLabel = medicalDiagnoses?.join(", ") || "-";

  const displayOptionalValue = (value: string | number | null | undefined) =>
    value === "" || value === null || value === undefined ? "-" : value;

  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <Grid item xs={12}>
        <FieldItem label="Diagnosis" value={diagnosis?.label || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Diagnosis date (primary)" value={formattedDate} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Additional diagnoses (mental health and neurodevelopmental)"
          value={additionalDiagnosesLabel}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Medical diagnoses" value={medicalDiagnosesLabel} />
      </Grid>
      {diagnosis?.code === AUTISM_DIAGNOSES_CODE && (
        <>
          <Grid item xs={12}>
            <FieldItem
              label="ASD severity - social communication"
              value={asdSeveritySocialLabel || "-"}
            />
          </Grid>
          <Grid item xs={12}>
            <FieldItem
              label="ASD severity - restricted, repetitive behaviors"
              value={asdSeverityRestrictedLabel || "-"}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <FieldItem label="IQ test on file" value={iqTest || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Full scale IQ score" value={displayOptionalValue(iqScore)} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="CARS-2 type" value={cars2Type || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="CARS-2 t-score" value={displayOptionalValue(cars2TScore)} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem label="Treatment modality" value={treatmentModality || "-"} />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Evaluation for Comorbid Diagnoses"
          value={evaluationForComorbidDiagnoses || "-"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Other symptoms and functional impairments observed"
          value={otherSymptomsObserved || "-"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Persistent Deficits in Social Communication and Interaction"
          value={persistentDeficitsSocialCommunication || "-"}
        />
      </Grid>
      <Grid item xs={12}>
        <FieldItem
          label="Restrictive, Repetitive Patterns of Behavior or Activity"
          value={restrictiveRepetitivePatterns || "-"}
        />
      </Grid>
    </Grid>
  );
};

export default ViewFields;
